
export const processDetailHtml = (htmlString, options = {}) => {
  const { hideQr = false } = options;
  if (!htmlString || typeof htmlString !== 'string') return htmlString;

  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlString, 'text/html');

  // 1. Clean up "Order Date :" in <p> tags and other potential date containers
  const pTags = doc.querySelectorAll('p');
  pTags.forEach(p => {
    if (p.innerHTML.includes('Order Date :')) {
      const parts = p.innerHTML.split('Order Date :');
      if (parts.length > 1) {
        const dateMatch = parts[1].match(/\d{1,2}[-/]\d{1,2}[-/]\d{2,4}/);
        if (dateMatch) {
            p.innerHTML = `${parts[0]}Order Date :</strong> ${dateMatch[0]}`;
        }
      }
    }
  });

  // 2. Clean up dates in Previous Pending Orders table (Column 2)
  const prevTable = doc.querySelector('.prev-orders-table');
  if (prevTable) {
    const rows = prevTable.querySelectorAll('tbody tr');
    rows.forEach(row => {
      const cells = row.querySelectorAll('td');
      if (cells.length >= 2) {
        const dateText = cells[1].textContent.trim();
        if (dateText) {
          const dateMatch = dateText.match(/\d{1,2}[-/]\d{1,2}[-/]\d{2,4}/);
          if (dateMatch) {
              cells[1].textContent = dateMatch[0];
          }
        }
      }
    });
  }

  // 3. Inject styles to fix the "messy" layout and unify UI
  let styleTag = doc.querySelector('style');
  if (!styleTag) {
    styleTag = doc.createElement('style');
    doc.head.appendChild(styleTag);
  }

  // Wrap the body content in a container to scope styles
  const originalBody = doc.body.innerHTML;
  doc.body.innerHTML = `<div class="print-preview-container">${originalBody}</div>`;

  const additionalStyles = `
    /* Zero margin for actual printing only */
    @media print {
      @page { margin: 0; }
      body { margin: 0 !important; padding: 0 !important; width: 100% !important; }
      .print-preview-container { border: none !important; box-shadow: none !important; margin: 0 !important; }
    }

    /* Scoped container for the thermal roll layout */
    .print-preview-container {
        max-width: 250px !important;
        width: 100% !important;
        margin: 0 auto !important;
        padding: 10px !important;
        box-sizing: border-box !important;
        font-family: 'Times New Roman', serif !important;
        font-size: 10px !important;
        color: #000 !important;
        background: #fff !important;
    }

    /* Standardize all tables within the preview */
    .print-preview-container table {
        width: 100% !important;
        border-collapse: collapse !important;
        margin-top: 5px !important;
        margin-bottom: 5px !important;
    }
    
    ${hideQr ? '.print-preview-container img[alt="barcode"], .print-preview-container .barcode { display: none !important; }' : ''}
    
    .print-preview-container table th, 
    .print-preview-container table td {
        padding: 4px 2px !important;
        font-size: 10px !important; 
        text-align: left !important;
        vertical-align: top !important;
        word-break: break-word !important;
        overflow-wrap: break-word !important;
        color: #000 !important;
    }

    /* Section Separators */
    .print-preview-container thead tr { 
        border-bottom: 1px solid #000 !important; 
    }

    /* Hide redundant HR tags that create "middle lines" */
    .print-preview-container hr {
        display: none !important;
    }

    /* Remove the dotted lines entirely to satisfy "still lines come" */
    .print-preview-container tbody tr {
        border-bottom: none !important;
    }

    .print-preview-container tfoot tr,
    .print-preview-container .total { 
        border-top: 1px solid #000 !important; 
        margin-top: 5px !important;
        padding-top: 5px !important;
    }

    /* Column specific alignment */
    .print-preview-container table th:last-child, 
    .print-preview-container table td:last-child {
        text-align: right !important;
        white-space: nowrap !important;
    }

    /* Fixed widths to prevent wrapping */
    .print-preview-container .prev-orders-table th:nth-child(1), 
    .print-preview-container .prev-orders-table td:nth-child(1),
    .print-preview-container table th:nth-child(1), 
    .print-preview-container table td:nth-child(1) { width: 45px !important; } 

    /* Prevent "Go ld" wrapping */
    .print-preview-container table th:nth-child(3), 
    .print-preview-container table td:nth-child(3) { min-width: 40px !important; } 
    
    /* Title and Header styling */
    .print-preview-container p:first-child { 
        text-align: center !important; 
        font-weight: bold !important; 
        font-size: 14px !important; 
        text-transform: uppercase !important;
        margin-bottom: 8px !important;
    }

    .print-preview-container h1 { font-size: 14px !important; margin: 5px 0 !important; text-align: center !important; text-transform: uppercase !important; }
    .print-preview-container p { margin: 2px 0 !important; font-size: 10px !important; line-height: 1.2 !important; color: #000 !important; }
    
    .print-preview-container .total p, 
    .print-preview-container .footer p { margin: 2px 0 !important; font-weight: bold !important; font-size: 11px !important; }
    
    /* Utility to hide things if needed */
    .print-preview-container .no-print { display: none !important; }

    .print-preview-container hr { border: 0; border-top: 1px solid #000; margin: 5px 0; }
  `;

  styleTag.textContent = additionalStyles;

  return doc.documentElement.outerHTML;
};
